function $e814209ad347a3ed$export$7df07f18f1d2d847() {
    const backToTopElement = document.querySelector(".back-to-top-link");
    document.body.addEventListener("keyup", (event)=>{
        const keyName = event.key;
        if (keyName === "Control") return;
        if (event.ctrlKey && keyName === "/") {
            window.scrollTo({
                top: 0
            });
            $e814209ad347a3ed$var$focusOnBody();
        }
    });
    backToTopElement.addEventListener("click", (event)=>{
        event.preventDefault();
        window.scrollTo({
            top: 0
        });
        $e814209ad347a3ed$var$focusOnBody();
    });
}
function $e814209ad347a3ed$var$focusOnBody() {
    document.body.setAttribute("tabindex", "-1");
    document.body.focus();
    document.body.removeAttribute("tabindex");
}


async function $30e08e41953bed94$export$fd8788cd3e904d4e() {
    const postDomain = new URL(window.location.href).origin.includes("localhost") ? "https://blog.krvpb024.dev" : new URL(window.location.href).origin;
    const postId = new URL(window.location.href).pathname;
    const fetchUrl = `https://webmention.io/api/count?target=${postDomain}${postId}`;
    const fetchResponse = await fetch(fetchUrl);
    const fetchData = await fetchResponse.json();
    const { type: { like: like, reply: reply, repost: repost } } = fetchData;
    const likeCountElement = document.querySelector(".like-count");
    const replyCountElement = document.querySelector(".reply-count");
    const repostCountElement = document.querySelector(".repost-count");
    if (likeCountElement) likeCountElement.innerHTML = like ?? 0;
    if (replyCountElement) replyCountElement.innerHTML = reply ?? 0;
    if (repostCountElement) repostCountElement.innerHTML = repost ?? 0;
}


if (document.getElementById("webmention")) (0, $30e08e41953bed94$export$fd8788cd3e904d4e)();
(0, $e814209ad347a3ed$export$7df07f18f1d2d847)();


//# sourceMappingURL=index.7b08f716.js.map
